import { switchMap, of, catchError } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';

/**
 *  getTypeaheadSuggestions: function to fetch suggestion from any source.
 *  @param {string} url: url source to fetch suggestions.
 */
const getTypeaheadSuggestions = function (url) {
  return fromFetch(url, {
    headers: {
      'Accept': 'application/json',
    }
  }).pipe(
    switchMap((response) => response.json()),
    catchError(() => of([]))
  );
}

export default getTypeaheadSuggestions;

